import React, { createContext, useContext, useEffect, useState } from 'react';
import { getSubdomain } from '../services/api.service';

const SubdomainContext = createContext();

const getSubdomainFromHostname = (hostname) => {
    const host = String(hostname || '')
        .toLowerCase()
        .trim();

    // Local main domain
    if (host === 'localhost' || host === '127.0.0.1') {
        return null;
    }

    // Local tenant: lcb.localhost
    if (host.endsWith('.localhost')) {
        return host.split('.')[0] || null;
    }

    const PROD_ROOT = 'services.fiskagroup.com';
    const BETA_ROOT = 'beta.services.fiskagroup.com';

    // Main production website
    if (host === PROD_ROOT) {
        return null;
    }

    // Main beta website
    if (host === BETA_ROOT) {
        return null;
    }

    // Example:
    // lcb.beta.services.fiskagroup.com
    if (host.endsWith(`.${BETA_ROOT}`)) {
        const prefix = host.slice(
            0,
            -(BETA_ROOT.length + 1)
        );

        return prefix || null;
    }

    // Example:
    // lcb.services.fiskagroup.com
    if (host.endsWith(`.${PROD_ROOT}`)) {
        const prefix = host.slice(
            0,
            -(PROD_ROOT.length + 1)
        );

        return prefix || null;
    }

    return null;
};

const getUserIdFromUrl = () => {
    const params = new URLSearchParams(window.location.search);

    return params.get('userId') || params.get('userid') || null;
};

const userId = getUserIdFromUrl();

export const SubdomainProvider = ({ children }) => {
    const hostname = window.location.hostname;
    const subdomain = getSubdomainFromHostname(hostname);

    const [subdomainData, setSubdomainData] = useState(null);
    const [loadingSubdomain, setLoadingSubdomain] = useState(true);

    useEffect(() => {
        if (!subdomain || subdomain === 'beta') {
            setLoadingSubdomain(false);
            return;
        }

        const fetchSubdomainData = async () => {
            try {
                setLoadingSubdomain(true);

                const currentUserId = getUserIdFromUrl();
                const data = await getSubdomain(subdomain, currentUserId);

                setSubdomainData(data);
            } catch (error) {
                console.error('[SubdomainProvider] failed to fetch subdomain data:', error);
                setSubdomainData(null);
            } finally {
                setLoadingSubdomain(false);
            }
        };

        fetchSubdomainData();
    }, [subdomain]);

    return (
        <SubdomainContext.Provider value={{ subdomain, userId, subdomainData, loadingSubdomain }}>
            {children}
        </SubdomainContext.Provider>
    );
};

export const useSubdomain = () => useContext(SubdomainContext);